import React from 'react'
import {
  MaterialIcon,
  MaterialIconRef,
} from 'src/components/framework/icons/material-icon'
import { Fill } from 'src/components/framework/ui'
import { useSecurityContext } from 'src/contexts/security.context'
import { Colors } from 'src/shared/colors'
import { makeUnlockLink } from 'src/shared/utils'

import * as styles from './cta.module.scss'

export interface Props {
  style?: React.CSSProperties
  includeLabel?: boolean
}

export const CTA: React.FC<Props> = ({ includeLabel = true, style }) => {
  const { security } = useSecurityContext()

  return (
    <a
      href={makeUnlockLink()}
      target="_blank"
      className={styles.cta}
      style={style}
      aria-label="Subscribe to view"
    >
      <div className={styles.cta__padlockCircle}>
        <MaterialIcon
          icon={MaterialIconRef.Locker}
          color={Colors.White}
          size={14}
        />
      </div>

      <Fill />

      {includeLabel && (
        <span className={styles.cta__label}>Subscribe to view</span>
      )}
    </a>
  )
}
